"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.weak-map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.array.map.js");

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _Geometry = _interopRequireDefault(require("ol/geom/Geometry"));

var _Window = _interopRequireDefault(require("../../base/Window/Window"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["title", "style", "features", "onClose", "onCancel", "visible"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FeaturePropertiesWnd = function FeaturePropertiesWnd(_ref) {
  var title = _ref.title,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {
    width: 500
  } : _ref$style,
      features = _ref.features,
      onClose = _ref.onClose,
      onCancel = _ref.onCancel,
      visible = _ref.visible,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  /**
   * Method to build the Table datasources from the array of features
   * 
   */
  var buildDataSourcesFromFromFeatures = (0, _react.useCallback)(function (features) {
    if (!features || features.length === 0) return [[]];
    var dataSources = [];
    features.forEach(function (feature) {
      var properties = feature.getProperties();
      var idx = 0;
      var dataSource = [];

      for (var property in properties) {
        var item = {};

        if (!(properties[property] instanceof _Geometry.default)) {
          item['key'] = idx.toString();
          item['name'] = property;
          item['value'] = properties[property];
          idx = idx + 1;
          dataSource.push(item);
        }
      }

      dataSources.push(dataSource);
    });
    return dataSources;
  }, []);
  var getFeatureIds = (0, _react.useCallback)(function (features) {
    var ids = [];
    if (!features || features.length === 0) return ids;
    features.forEach(function (feature) {
      ids.push(feature.getId());
    });
    return ids;
  }, []);

  var _useState = (0, _react.useState)(buildDataSourcesFromFromFeatures(features)),
      _useState2 = _slicedToArray(_useState, 2),
      dataSources = _useState2[0],
      setDataSources = _useState2[1];

  var _useState3 = (0, _react.useState)(getFeatureIds(features)),
      _useState4 = _slicedToArray(_useState3, 2),
      featureIds = _useState4[0],
      setFeatureIds = _useState4[1];

  var columns = [{
    title: 'Name',
    dataIndex: 'name',
    key: 'name'
  }, {
    title: 'Value',
    dataIndex: 'value',
    key: 'value'
  }];
  var scroll = {
    scrollToFirstRowOnChange: true,
    x: 400,
    y: 400
  };
  (0, _react.useEffect)(function () {
    if (features && features.length > 0) {
      setDataSources(buildDataSourcesFromFromFeatures(features));
      setFeatureIds(getFeatureIds(features));
    }
  }, [buildDataSourcesFromFromFeatures, features, getFeatureIds]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Window.default, _objectSpread(_objectSpread({
    title: title,
    collapsible: true,
    visible: visible,
    onCancel: onCancel,
    onClose: onClose,
    style: style
  }, otherProps), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Tabs, {
      defaultActiveKey: ['0']
      /*style={{ height: 400}}*/
      ,
      tabPosition: "top",
      children: dataSources.map(function (dataSource, idx) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Tabs.TabPane, {
          tab: featureIds[idx],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Table, {
            dataSource: dataSource,
            columns: columns,
            size: "middle",
            tableLayout: "auto",
            pagination: false,
            scroll: scroll,
            bordered: true,
            sticky: true
          })
        }, idx.toString());
      })
    })
  }));
};

var _default = FeaturePropertiesWnd;
exports.default = _default;